import { React, useEffect } from "react";
import { ConfirmInfo, Header, PaginationHelper, TitleBar } from "webapp/components";
import { useTranslation } from "react-i18next";
import { AppState } from "webapp/enums/AppState";

/**
 *
 * @param {
 * callBackFunc - callbackfunction that completes the submission of overall information
 * data - general data that populates the confirminfo value
 * confirmInfoDisab - legacy disablement update
 * confirmInfoDest - legacy destination update
 * backButtonFunc - original backbuttonfunc which regresses the app to confirm destination, or
 *
 * backButtonFunc2 -
 * } props
 * @returns
 */
export default function ConfirmInformation(props) {
  const { t } = useTranslation();
  const LocateUserObj = {
    img: props.logo,
    partner: props.currState.partner,
    fragment: (
      <>
        <p className="mb-0">
          <strong>
            {t(
              "description.ConfirmInformationTitleBar1" +
                (props.currState.localGroup === "TVL" ? "TVL" : ""),
            )}
          </strong>
          <br />
          <span style={{ color: "#999" }}>
            {t(
              "description.ConfirmInformationTitleBar2" +
                (props.currState.localGroup === "TVL" ? "TVL" : ""),
            )}
          </span>
        </p>
      </>
    ),
  };

  const onChangeAppState = (state) => {
    props.context.setState({ webAppState: state });
  };

  const onUserNext = (data) => {
    if (typeof props.onUserNext === "function") {
      props.onUserNext(data);
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onEditUserLocation = () => {
    const context = props.context;

    context.setState({
      webAppState: AppState.LocateUser,
      ConfirmInfoFlag: !context.state.ConfirmInfoFlag,
      ReturnToConfirm: true,
    });
  };

  return (
    <>
      <Header
        currState={props.currState}
        onUserBack={props.onUserBack}
        information={t("description.ConfirmInformationHeader1")}
      />
      <TitleBar data={LocateUserObj} />
      <PaginationHelper context={props.context} />
      <ConfirmInfo
        locale={props.currState.DisablementCountry || props.currState.locale}
        localGroup={props.currState.localGroup}
        onEditService={onChangeAppState}
        onEditDestination={onChangeAppState}
        onEditUserLocation={onEditUserLocation}
        onUserNext={onUserNext}
        onUserCancel={onUserCancel}
        data={props.data}
        currState={props.currState}
      />
    </>
  );
}
